<ion-grid class="ion-no-padding">
  <ion-row>
    <!-- frequency type -->
    <ion-col size="12" size-md="6">
      <ion-list>
        <ion-radio-group [ngModel]="freqType" (ngModelChange)="onTypeChange($event)">
          <ion-list-header>
            <div class="c3-flex-column">
              <ion-label>Frequenza</ion-label>
              <ion-note
                >Specifica la frequenza di assunzione del farmaco durante la terapia</ion-note
              >
            </div>
          </ion-list-header>

          <ion-item lines="none">
            <ion-label>Al bisogno</ion-label>
            <ion-radio
              slot="start"
              color="secondary"
              [disabled]="disabled"
              value="at_need"
            ></ion-radio>
          </ion-item>

          <ion-item lines="none">
            <ion-label>Ogni giorno</ion-label>
            <ion-radio
              slot="start"
              color="secondary"
              [disabled]="disabled"
              value="every_day"
            ></ion-radio>
          </ion-item>

          <ion-item lines="none">
            <ion-label>Ogni <code>n</code> giorni</ion-label>
            <ion-radio
              slot="start"
              color="secondary"
              [disabled]="disabled"
              value="every_x_days"
            ></ion-radio>
          </ion-item>

          <ion-item lines="none">
            <ion-label>In determinati giorni della settimana</ion-label>
            <ion-radio
              slot="start"
              color="secondary"
              [disabled]="disabled"
              value="day_of_week"
            ></ion-radio>
          </ion-item>

          <ion-item lines="none">
            <ion-label>In determinati giorni del mese</ion-label>
            <ion-radio
              slot="start"
              color="secondary"
              [disabled]="disabled"
              value="day_of_month"
            ></ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-list>
    </ion-col>

    <!-- frequency value -->
    <ion-col size="12" size-md="6">
      <ng-container [ngSwitch]="freqType">
        <!-- every x days -->
        <ng-container *ngSwitchCase="'every_x_days'">
          <p>Ogni quanti giorni?</p>
          <ion-item>
            <ion-label slot="start">Ogni</ion-label>
            <ion-input
              [disabled]="disabled"
              [pattern]="'^[1-9][0-9]*$'"
              type="number"
              [min]="1"
              [max]="31"
              [step]="1"
              [ngModel]="freqValue"
              (ngModelChange)="onValueChange($event)"
              required
            ></ion-input>
            <ion-label slot="end">giorni</ion-label>
          </ion-item>
        </ng-container>

        <!-- days of week -->
        <ng-container *ngSwitchCase="'day_of_week'">
          <p>In quali giorni della settimana?</p>

          <ion-item-group>
            <ion-item>
              <ion-label>Lunedì</ion-label>
              <ion-checkbox
                slot="start"
                color="secondary"
                [checked]="$any(freqValue).includes(1)"
                [value]="1"
                [disabled]="disabled"
                (ionChange)="onWeekDayToggle($event)"
              >
              </ion-checkbox>
            </ion-item>
            <ion-item>
              <ion-label>Martedì</ion-label>
              <ion-checkbox
                slot="start"
                color="secondary"
                [checked]="$any(freqValue).includes(2)"
                [value]="2"
                [disabled]="disabled"
                (ionChange)="onWeekDayToggle($event)"
              >
              </ion-checkbox>
            </ion-item>
            <ion-item>
              <ion-label>Mercoledì</ion-label>
              <ion-checkbox
                slot="start"
                color="secondary"
                [checked]="$any(freqValue).includes(3)"
                [value]="3"
                [disabled]="disabled"
                (ionChange)="onWeekDayToggle($event)"
              >
              </ion-checkbox>
            </ion-item>
            <ion-item>
              <ion-label>Giovedì</ion-label>
              <ion-checkbox
                slot="start"
                color="secondary"
                [checked]="$any(freqValue).includes(4)"
                [value]="4"
                [disabled]="disabled"
                (ionChange)="onWeekDayToggle($event)"
              >
              </ion-checkbox>
            </ion-item>
            <ion-item>
              <ion-label>Venerdì</ion-label>
              <ion-checkbox
                slot="start"
                color="secondary"
                [checked]="$any(freqValue).includes(5)"
                [value]="5"
                [disabled]="disabled"
                (ionChange)="onWeekDayToggle($event)"
              >
              </ion-checkbox>
            </ion-item>
            <ion-item>
              <ion-label>Sabato</ion-label>
              <ion-checkbox
                slot="start"
                color="secondary"
                [checked]="$any(freqValue).includes(6)"
                [value]="6"
                [disabled]="disabled"
                (ionChange)="onWeekDayToggle($event)"
              >
              </ion-checkbox>
            </ion-item>
            <ion-item>
              <ion-label>Domenica</ion-label>
              <ion-checkbox
                slot="start"
                color="secondary"
                [checked]="$any(freqValue).includes(7)"
                [value]="7"
                [disabled]="disabled"
                (ionChange)="onWeekDayToggle($event)"
              >
              </ion-checkbox>
            </ion-item>
          </ion-item-group>
        </ng-container>

        <!-- days of month -->
        <ng-container *ngSwitchCase="'day_of_month'">
          <p>In quali giorni del mese?</p>

          <ion-grid>
            <ion-row>
              <ion-col
                [size]="1.7142857142857142"
                *ngFor="let day of DAYS_IN_MONTH"
                class="c3-flex ion-justify-content-center ion-align-items-center"
              >
                <ion-button
                  [color]="$any(freqValue).includes(day) ? 'secondary' : 'dark'"
                  fill="clear"
                  shape="round"
                  (click)="onMonthDayToggle(day)"
                  [disabled]="disabled"
                >
                  <span>{{ day }}</span>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <!-- nothing to show -->
        </ng-container>
      </ng-container>
    </ion-col>
  </ion-row>
</ion-grid>
